'use strict';

/**
 *
 * @name: UserRun
 *
 */

function UserRun(
  apiUserService,
  apiSeasonsService,
  permissions,
  apiCategoryService,
  $rootScope,
  transObject,
  $localStorage
) {

  'ngInject';


  /**
   *
   * @CONFIG
   *
   */

  $rootScope.isSessionStorageSupported = _isSessionStorageNameSupported();
  $rootScope.isLocalStorageSupported = _isLocalStorageNameSupported();
  $rootScope.categoryList = undefined;
  $rootScope.notificationCategories = [];
  $rootScope.staticPageList = undefined;
  $rootScope.showAwardsLink = false;

  /**
   *
   * @PUBLIC
   *
   */


  /**
   *
   * @PRIVATE
   *
   */

  function _isLocalStorageNameSupported() {
    var testKey = 'test';
    try {
      var storage = window.localStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function _isSessionStorageNameSupported() {
    var testKey = 'test';
    try {
      var storage = window.sessionStorage;
      storage.setItem(testKey, '1');
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function _loadUser() {

    apiUserService
      .getUser()
      .then(function() {

        $rootScope.threeTimesAVirgin = 5;
      }, function() {

        $rootScope.profile = false;
        if ($rootScope.isLocalStorageSupported) {

          if ($localStorage.Nowness && $localStorage.Nowness.playlist && $localStorage.Nowness.playlist.threeTimesAVirgin) {

            $rootScope.threeTimesAVirgin = $localStorage.Nowness.playlist.threeTimesAVirgin;
          } else {

            $rootScope.threeTimesAVirgin = 0;
          }
        } else {
          $rootScope.threeTimesAVirgin = 0;
        }
      });
  }

  function _loadCategories() {

    apiCategoryService
      .getCategory()
      .then(function(res) {

        $rootScope.categoryList = $rootScope.categoryList || [];
        $rootScope.staticPageList = $rootScope.staticPageList || [];

        res.data.items.forEach(function(item, index) {

          item.sortIndex = index;
          transObject.translate(item);
          $rootScope.categoryList[item.id] = item;
          $rootScope.notificationCategories[item.id] = item;
        });

        res.data.pages.forEach(function(item, index) {

          item.sortIndex = index;
          transObject.translate(item);
          $rootScope.staticPageList[item.sortIndex] = item;
        });
      });
  }

  function _loadAwards () {
    if ($rootScope.lang !== 'en-us') return

    apiSeasonsService
      .getSeasons(null,1,null,null,null,'custom-award')
      .then(function(result) {
        $rootScope.showAwardsLink = result.data.items.length
      });
  }

  /**
   *
   * @RUN
   *
   */

  _loadUser();
  _loadCategories();
  _loadAwards();
  permissions.nightWatch();
}

export default UserRun;



// WEBPACK FOOTER //
// ./app/pages/user/user.run.js